import CritiqueReviewBanner from './CritiqueReviewBanner'
export default CritiqueReviewBanner
